import {
  createClient,
  FindOperation,
  getRequestFactory,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';
import { AuditLog } from './model';

const client = createClient('/rest/audit-logs');

// These lib files do not like the Vue import.meta.env, but it does in fact exist
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const { VITE_UTILS_APP_PERMISSION_PREFIX = '' } = import.meta.env;

export const auditLogPermissions = {
  SEARCH: `${VITE_UTILS_APP_PERMISSION_PREFIX}.search-audit-logs`,
  GET: `${VITE_UTILS_APP_PERMISSION_PREFIX}.get-audit-log`,
  GET_OBJECT_TYPES: `${VITE_UTILS_APP_PERMISSION_PREFIX}.get-audit-log-object-types`
};

export const getAllObjectTypes: FindOperation<string[]> = getRequestFactory<string[]>(client, {
  pattern: '/object-types',
  permissionId: auditLogPermissions.GET_OBJECT_TYPES
});
export const searchAuditLogs: SearchOperation<AuditLog> = searchRequestFactory<AuditLog>(client, {
  pattern: '',
  permissionId: auditLogPermissions.SEARCH
});
export const getAuditLog: FindOperation<AuditLog, string> = getRequestFactory<AuditLog, string>(client, {
  permissionId: auditLogPermissions.GET
});
